enum CleaningCategory {
  Activity,
  NotificationCategory,
}

export default CleaningCategory;
